export default "../css/8adae7b5a63f7a9dbc828a1051caa04e.ttf";